<template>
<div>
    <div>
        <header-bar></header-bar>
        <swiper-bar :swiperItem="swiperItem"></swiper-bar>
        <div class="container">
            <div class="publish-way">
                <h4>出版流程</h4>
                <div class="publish-way-img">
                    <img src="https://www.lishushu51.com/img/publish-way.png?v=1616057946caxcfdioqwnfqxcj125456lasa" alt="出版流程" title="出版流程">
                </div>
            </div>
        </div>
        <div class="publish-new">
        <h4 class="soli-info">出版信息</h4>
        <div class="solicitation-full">
            <div class="container solicitation">
                <div class="publish-Solicitation row">
                    <div class="col-md-3" style="max-width: 25%;">
                        <ul id="myTab" class="nav nav-tabs solicitation-tabs">
                            <li><a href="#books1" data-toggle="tab" class="active">《高中美术课程与****论》</a> </li>
                            <li><a href="#books3" data-toggle="tab">《装饰性地面铺装工艺****》</a></li>
                            <li><a href="#books4" data-toggle="tab">《****物流管理职业管理模式创新研究》</a></li>
                            <li><a href="#books5" data-toggle="tab">《传统陈设艺术与室内装饰***》</a></li>
                            <li><a href="#books6" data-toggle="tab">《音乐教学——****的新路径》</a></li>
                            <li><a href="#books7" data-toggle="tab">《英语阅读****与实践》</a></li>
                            <li><a href="#books8" data-toggle="tab">《**经济体系构建新理念》</a></li>
                            <li><a href="#books9" data-toggle="tab">《小学语文****实践研究》</a></li>
                            <li><a href="#books10" data-toggle="tab">《高中英语教学****》</a></li>
                        </ul>
                    </div>
                    <div class="col-md-9 solicitation-right" style="max-width: 75%;">
                        <div id="solicitation-content" class="tab-content">
                            <div class="tab-pane fade show in active" id="books1">
                                <div class="boos-right-top"> 征集第一主编、第二主编、第三主编。已完稿，预计今年出版。</div>
                                <div class="books-content">
                                    <p>内容简介：</p>
                                    <div class="books-intrudus">
                                        21世纪是经济全球化的时代，中国的美术教育必须呈现新的亮点，必须担当起承前启后、继往开来的历史重任。当代美术教育改革也不可避免地依然会面对从传统中吸取营养而不断充实、发展的现实，深入挖掘人类传统美术的精华，公允地评价传统的意义，全方位地重塑美术教育的价值体系，这已经是当今美术教育工作者，尤其是高中美术教育工作者的神圣使命。
                                    </div>
                                    <p class="catalogue">目录</p>
                                    <ul>
                                        <li>第一章 美术教育概述</li>
                                        <li>第二章 核心素养与美术教学</li>
                                        <li>第三章 多媒体与美术教学</li>
                                        <li>第四章 新课标下的美术教学</li>
                                        <li>第五章 生态理论下的美术教学</li>
                                        <li>第六章 “鉴赏”美术教学</li>
                                        <li>第七章 互动教学策略</li>
                                        <li>第八章 合作学习策略</li>
                                        <li>第九章 翻转课堂教学策略</li>
                                        <li>第十章 创新思维教学策略</li>
                                        <li>第十一章 多元化模式与评价</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="tab-pane fade show in " id="books3">
                                <div class="boos-right-top"> 征集第一主编、第二主编、第三主编。已完稿，预计今年出版。</div>
                                <div class="books-content">
                                    <p>内容简介：</p>
                                    <div class="books-intrudus">
                                        地面铺装的目的是保护结构的安全，增强地面的美化功能，使地面脚感舒适、使用安全、清理方便、易于保持。对于地面铺装来说，就像在设计一幅图，其过程必然包含材料、技术、色彩和图案等方面。本书即从地面铺装的基本概念谈起，并针对地面铺装的各种材料的装饰工艺以及地面铺装的色彩选择和图案选择入手，全面分析了地面铺装的各个环节。
                                    </div>
                                    <p class="catalogue">目录</p>
                                    <ul>
                                        <li>第一章 地面铺装及其材料解读</li>
                                        <li>第二章 地面铺装的色彩与图案的装饰性</li>
                                        <li>第三章 木质地板铺装的装饰性</li>
                                        <li>第四章 卷材地面铺装的装饰性</li>
                                        <li>第五章 板块地面铺装的装饰性</li>
                                        <li>第六章 抗静电活动地面铺装的装饰性</li>
                                        <li>第七章 特殊面层地面铺装的装饰性</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="tab-pane fade show in " id="books4">
                                <div class="boos-right-top"> 征集第一主编、第二主编、第三主编。已完稿，预计今年出版。</div>
                                <div class="books-content">
                                    <p>内容简介：</p>
                                    <div class="books-intrudus">
                                        本书结合我国现代物流专业的发展对物流专业教育进行研究。全书共六章，内容包括：大数据与现代物流探析；现代物流管理职业教育初探；基于国际视野的现代物流管理职业教育研究；物流管理职业教育专业教学实践研究；物流管理产学研合作教学模式研究；大数据背景下物流管理职业教育创新研究。
                                    </div>
                                    <p class="catalogue">目录</p>
                                    <ul>
                                        <li>第一章 大数据与现代物流探析</li>
                                        <li>第二章 现代物流管理职业教育初探</li>
                                        <li>第三章 基于国际视野的现代物流管理职业教育研究</li>
                                        <li>第四章 物流管理职业教学实践研究</li>
                                        <li>第五章 物流管理产学研合作教学模式研究</li>
                                        <li>第六章 抗静电活动地面铺装的装饰性</li>
                                        <li>第七章 大数据背景下物流管理职业教育创新研究</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="tab-pane fade show in " id="books5">
                                <div class="boos-right-top"> 征集第一主编、第二主编、第三主编。已完稿，预计今年出版。</div>
                                <div class="books-content">
                                    <p>内容简介：</p>
                                    <div class="books-intrudus">
                                        21世纪的今天，室内设计大力提倡人文关怀，具体到室内陈设艺术设计上，应该向生态化、个性化、舒适化和文化层面发展；吸收传统文化元素装饰当代居室空间，要有效地把握空间意境，使当代中式风格的居室陈设设计从简单、初级的“形似”上升到较高层次的“神似”，进而追求“形神兼备”的艺术效果。其最终的目的就是将中国传统民居室内陈设艺术的文化精神和品格与当代人的情感、生活和审美需求进行完美结合，创立人性化的当代中式风格的居室陈设艺术设计。本书的重点内容有四部分：第一部分对陈设进行概述；第二部分重点介绍了中国传统陈设的功能、材质及其使用性质；第三部分针对不同地域的陈设装饰进行分析；第四部分总结了传统陈设的艺术性和文化性。
                                    </div>
                                    <p class="catalogue">目录</p>
                                    <ul>
                                        <li>第一章 陈设概述</li>
                                        <li>第二章 艺术理念</li>
                                        <li>第三章 文化传承</li>
                                        <li>第四章 审美价值</li>
                                        <li>第五章 陶瓷</li>
                                        <li>第六章 漆材质语言</li>
                                        <li>第七章 空间陈设设计</li>
                                        <li>第八章 不同地域的陈设</li>
                                        <li>第九章 传统陈设的艺术性和文化性</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="tab-pane fade show in " id="books6">
                                <div class="boos-right-top"> 征集第一主编、第二主编、第三主编。已完稿，预计今年出版。</div>
                                <div class="books-content">
                                    <p>内容简介：</p>
                                    <div class="books-intrudus">
                                        本书通过对音乐基础知识、音乐欣赏种类、音乐欣赏教学现状的介绍与研究，揭示音乐欣赏与审美教育、音乐欣赏与情感体验、音乐欣赏与创造性思维、音乐欣赏与心理健康、音乐欣赏与人文素质、音乐欣赏与文化素养等素质教育的关系，形成系统、全面、立体的音乐欣赏与素质教育关系体系。并与教学实践相结合，将素质教育的思想与落实渗透于音乐欣赏的各个组成部分，由此探索21世纪更加适合音乐欣赏教学和素质教育的教学新路径。
                                    </div>
                                    <p class="catalogue">目录</p>
                                    <ul>
                                        <li>第一章 音乐欣赏概述</li>
                                        <li>第二章 音乐欣赏种类</li>
                                        <li>第三章 音乐欣赏教学现状</li>
                                        <li>第四章 音乐欣赏与审美教育</li>
                                        <li>第五章 音乐欣赏与情感体验</li>
                                        <li>第六章 音乐欣赏与创造性思维</li>
                                        <li>第七章 音乐欣赏与心理健康</li>
                                        <li>第八章 音乐欣赏与人文素质</li>
                                        <li>第九章 音乐欣赏与文化素养</li>
                                        <li>第十章 音乐欣赏与素质教育教学新路径探索</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="tab-pane fade show in " id="books7">
                                <div class="boos-right-top"> 征集第一主编、第二主编、第三主编。已完稿，预计今年出版。</div>
                                <div class="books-content">
                                    <p>内容简介：</p>
                                    <div class="books-intrudus">
                                        本书的内容共有五章。第一章论述了英语教师实践性知识以及话语的相关研究。第二章阐述了高中英语教师知识储备的相关研究。第三章阐述了高中英语教师技能修炼的相关研究。第四章从词汇、写作、阅读三个方面论述了高中英语教学活动设计的相关研究。第五章诠释了人文素质培养视域下英语个性化教学的相关研究。
                                    </div>
                                    <p class="catalogue">目录</p>
                                    <ul>
                                        <li>第一章 导论</li>
                                        <li>第二章 高中英语教师的知识储备</li>
                                        <li>第三章 高中英语教师的技能修炼</li>
                                        <li>第四章 高中英语教学活动设计解析</li>
                                        <li>第五章 基于人文素质培养的英语个性化教学</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="tab-pane fade show in " id="books8">
                                <div class="boos-right-top"> 征集第一主编、第二主编、第三主编。已完稿，预计今年出版。</div>
                                <div class="books-content">
                                    <p>内容简介：</p>
                                    <div class="books-intrudus">
                                        本书基于新发展理念，先从我国发展理念的与时俱进开篇，围绕新发展理念讨论了新发展理念提出的时代背景及其所蕴含的哲学智慧，接着阐述了新发展理念的科学内涵、意义及落实策略。然后分析了我国经济体系的构建相关问题，涉及现代化经济体系的内容以及新发展理念在经济体系建构中的表现，主要包括建设创新型国家、区域协调发展、乡村振兴、面开放新格局等方面。最后提出落实新发展理念，完善社会主义市场经济体制的相关措施。
                                    </div>
                                    <p class="catalogue">目录</p>
                                    <ul>
                                        <li>第一章 绪论</li>
                                        <li>第二章 科学理解“五大”新发展理念</li>
                                        <li>第三章 新发展理念下的当代中国经济</li>
                                        <li>第四章 现代化经济体系的内容</li>
                                        <li>第五章 新发展理念在现代经济体系建构中的表现</li>
                                        <li>第六章 落实新发展理念，完善社会主义市场经济体制</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="tab-pane fade show in " id="books9">
                                <div class="boos-right-top"> 征集第一主编、第二主编、第三主编。已完稿，预计今年出版。</div>
                                <div class="books-content">
                                    <p>内容简介：</p>
                                    <div class="books-intrudus">
                                        阅读教学要处理好整体与局部的关系。阅读的关键和基础都是对文本的深入理解。阅读教学强调整体感知是针对肢解文本来说的，但光有整体感知是不够的。“读书百遍其意自见”，阅读教学中要强调读，要重视对文本情感的体验、内容的领悟、写法的探究、语言的品味。教师的讲解要少而精，要能调动起学生的思维。在搞好课内阅读教学的同时，要加强课外阅读指导。广泛的阅读的目的不仅在于增加语言积累、培养语感，还在于培养自主阅读意识，养成良好阅读习惯，通过整体把握、重点赏读、精心揣摩形成科学的阅读方法，故教师应重视学生的课外阅读指导。课外阅读的指导应将学式，运用语文知识与语文能力来解决生活的实际问题。
                                    </div>
                                    <p class="catalogue">目录</p>
                                    <ul>
                                        <li>第一章 语文学科概述</li>
                                        <li>第二章 语文课堂内容分析</li>
                                        <li>第三章 语文课堂教学问题现状</li>
                                        <li>第四章 语文课堂教学问题解决对策</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="tab-pane fade show in " id="books10">
                                <div class="boos-right-top"> 征集第一主编、第二主编、第三主编。已完稿，预计今年出版。</div>
                                <div class="books-content">
                                    <p>内容简介：</p>
                                    <div class="books-intrudus">
                                        本书的内容共有五章。第一章论述了英语教师实践性知识以及话语的相关研究。第二章阐述了高中英语教师知识储备的相关研究。第三章阐述了高中英语教师技能修炼的相关研究。第四章从词汇、写作、阅读三个方面论述了高中英语教学活动设计的相关研究。第五章诠释了人文素质培养视域下英语个性化教学的相关研究。
                                    </div>
                                    <p class="catalogue">目录</p>
                                    <ul>
                                        <li>第一章 导论</li>
                                        <li>第二章 高中英语教师的知识储备</li>
                                        <li>第三章 高中英语教师的技能修炼</li>
                                        <li>第四章 高中英语教学活动设计解析</li>
                                        <li>第五章 基于人文素质培养的英语个性化教学</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img src="https://www.lishushu51.com/img/contect.png" class="contact published">
        </div>
    </div>
    <!--出版书籍-->
    <!--knew us-->
    <div class="container knew-us">
       <div class="knew-us-bos">
           <h4>认识我们</h4>
           <div class="writings active">书籍出版</div>
           <div class="literature">著作挂编</div>
           <div class="row knew-us-bottom">
               <div class="col-md-3 introduce introduce-left published" title="点击咨询客服">
                   <div class="knew-us-left knew-us-left-one">
                       <img src="https://www.lishushu51.com/img/public_icon_01.png">
                   </div>
                   <div class="fonts">
                       <p class="big-font">不黄稿</p>
                       <p class="font-news">自营策划书<br/>
                           实时跟进  保证出版</p>
                   </div>
               </div>
               <div class="col-md-3 introduce introduce-left published" title="点击咨询客服">
                   <div class="knew-us-left knew-us-left-two">
                       <img src="https://www.lishushu51.com/img/public_icon_02.png">
                   </div>
                   <div class="fonts">
                       <p class="big-font">1对1服务</p>
                       <p class="font-news">精准推荐<br/>
                           打造专属作品</p>
                   </div>
               </div>
               <div class="col-md-3 introduce introduce-right published" title="点击咨询客服">
                   <div class="knew-us-right knew-us-right-one ">
                       <img src="https://www.lishushu51.com/img/public_icon_07.png">
                   </div>
                   <div class="fonts">
                       <p class="big-font">冰点价</p>
                       <p class="font-news">代理制为客户提供<br/>
                           全网最优渠道和最低价</p>
                   </div>
               </div>
               <div class="col-md-3 introduce introduce-right published" title="点击咨询客服">
                   <div class="knew-us-right knew-us-right-two">
                       <img src="https://www.lishushu51.com/img/public_icon_08.png">
                   </div>
                   <div class="fonts">
                       <p class="big-font">超快速</p>
                       <p class="font-news">专业流程<br/>
                           效率高</p>
                   </div>
               </div>
           </div>
       </div>
    </div>
    <!--knew us-->
    <!--代理合作-->
    <div class="container representative published">
        <img src="https://www.lishushu51.com/img/representative_01.png">
        <div class="representative-fonts">
            <h4>代理合作</h4>
            <p>酝智文化传媒不以赚取一时的暴利为目的，致力于与每位客户建立良好的<br/>
                战略合作关系，最优的渠道，最低的价格，最新的资讯，保障客户利益</p>
        </div>
    </div>
    <!--代理合作-->
    <div class="container  problems">
        <div class="row problems-box">
            <div class="col-md-6 problems-img">
                <img src="https://www.lishushu51.com/img/problem_01.png">
            </div>
            <div class="col-md-6 problems-more">
                <h4>问题解读</h4>
                <div class="problems-info">
                    <p class="big-fonts"><img src="https://www.lishushu51.com/img/problem.png">为什么会黄稿？</p>
                    <p class="small-font">一是主编未如期挂满；二是不良代理商赚取暴利，不及时跟进出版流程，导致书籍无法按时出版。</p>
                </div>
                <div class="problems-info">
                    <p class="big-fonts"><img src="https://www.lishushu51.com/img/problem.png">是否是正规图书？</p>
                    <p class="small-font">正规书号ISBN 、 CIP ，新闻出版广电总局可查询。</p>
                </div>
                <div class="problems-info">
                    <p class="big-fonts"><img src="https://www.lishushu51.com/img/problem.png">关于价格</p>
                    <p class="small-font">酝智文化传媒特殊的代理人合作机制和boss会员制，为您提供最低的价格和最优的渠道。</p>
                </div>
                <div class="problems-info">
                    <p class="big-fonts"><img src="https://www.lishushu51.com/img/problem.png">售后退款</p>
                    <p class="small-font">因不可抗拒原因无法出书的情况，与客户协商后退款。</p>
                </div>
            </div>
        </div>
    </div>
    <!--书籍样书-->
    <div class="container sample-container">
        <div  class="container sample-book">
            <h4>样书展示</h4>
            <!-- swiper -->
            <swiperb-bar :swiperItem="swiperItemb"></swiperb-bar>
        </div>
        <img src="https://www.lishushu51.com/img/lettile-mouse.png" class="little-mouse">
    </div>
    <!--书籍样书-->
        <footerBar></footerBar>
    </div>
</div>
</template>
<script>
import headerBar from './header/Header'
import footerBar from './footer/Footer'
import swiperBar from './swiper/Swiper'
import swiperbBar from './swiper/Swiperb'
export default {
    components: {
        headerBar,
        footerBar,
        swiperBar,
        swiperbBar,
    },
    data () {
        return {
            swiperItem:[
                {
                    img:"/static/banner_02.png",
                    title:"知识产权，点击咨询客服"
                },
                {
                    img:"/static/banner_01.png",
                    title:"知识产权，点击咨询客服"
                },
                {
                    img:"/static/banner_03.png",
                    title:"知识产权，点击咨询客服"
                }
            ],
            swiperItemb:[
                {
                    img:"/static/books_01.jpg",
                    title:"出版流程",
                    bookname:"《农业供给侧改革背景下的有效供给与农产品竞争力》",
                    public:"九州出版社"
                },
                {
                    img:"/static/books_02.jpg",
                    title:"出版流程",
                    bookname:"《教育绿色建筑及工业建筑节能》",
                    public:"云南大学出版社"
                },
                {
                    img:"/static/books_03.jpg",
                    title:"出版流程",
                    bookname:"《小学美术与其他学科融合教学新视野》",
                    public:"云南出版集团 | 云南美术出版社"
                },
                {
                    img:"/static/books_04.jpg",
                    title:"出版流程",
                    bookname:"《新时代民族地区教育工作者能力与素养研究》",
                    public:"云南出版集团 | 云南美术出版社"
                },
                {
                    img:"/static/books_05.jpg",
                    title:"出版流程",
                    bookname:"《图书馆管理与信息应用》",
                    public:"辽海出版社"
                },
                {
                    img:"/static/books_06.jpg",
                    title:"出版流程",
                    bookname:"《儒家六艺中礼乐思想与校园文化建设》",
                    public:"辽海出版社"
                },
                {
                    img:"/static/books_07.jpg",
                    title:"出版流程",
                    bookname:"《书缘是一辈子的事》",
                    public:"云南出版集团 | 云南美术出版社"
                },
                {
                    img:"/static/books_08.jpg",
                    title:"出版流程",
                    bookname:"《民族器乐的发展与继承》",
                    public:"吉林美术出版社 | 全国百佳图书出版单位"
                }
               
            ],
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Publish.vue